import React from 'react';
import { Phone, Mail, MapPin, Facebook, Instagram, Youtube } from 'lucide-react';
import { bandInfo } from '../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const quickLinks = [
    { name: 'Početna', href: '#home' },
    { name: 'O nama', href: '#about' },
    { name: 'Usluge', href: '#services' },
    { name: 'Galerija', href: '#gallery' },
    { name: 'Kontakt', href: '#contact' }
  ];

  const services = ['Svadbe', 'Rođendani', 'Korporativni eventi', 'Krštenja i slave', 'Maturske večeri'];

  return (
    <footer className="bg-black relative overflow-hidden">
      {/* Top Border */}
      <div className="absolute top-0 left-0 w-full h-[1px] bg-gradient-to-r from-transparent via-gold-400/30 to-transparent" />

      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-20">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
          {/* Brand */}
          <div className="sm:col-span-2 lg:col-span-1">
            <img src={bandInfo.logo} alt={bandInfo.name} className="h-14 w-auto mb-6" />
            <p className="text-white/40 leading-relaxed mb-8 font-light text-sm">
              Profesionalni bend za sve vrste proslava na teritoriji cele Srbije.
            </p>
            {/* Social Links */}
            <div className="flex gap-4">
              {[Facebook, Instagram, Youtube].map((Icon, index) => (
                <a
                  key={index}
                  href="#"
                  className="w-10 h-10 border border-white/10 flex items-center justify-center hover:border-gold-400/50 hover:bg-gold-400/5 transition-all duration-300"
                >
                  <Icon className="w-4 h-4 text-white/50 hover:text-gold-400" />
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-medium tracking-[0.2em] uppercase text-sm mb-6">Linkovi</h4>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    onClick={(e) => { e.preventDefault(); scrollToSection(link.href); }}
                    className="text-white/40 hover:text-gold-400 transition-colors duration-300 text-sm font-light"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white font-medium tracking-[0.2em] uppercase text-sm mb-6">Usluge</h4>
            <ul className="space-y-3">
              {services.map((service) => (
                <li key={service} className="text-white/40 text-sm font-light">{service}</li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-medium tracking-[0.2em] uppercase text-sm mb-6">Kontakt</h4>
            <ul className="space-y-4">
              <li>
                <a href={`tel:${bandInfo.phone.replace(/\s/g, '')}`} className="flex items-center gap-3 text-white/40 hover:text-gold-400 transition-colors duration-300 text-sm font-light">
                  <Phone className="w-4 h-4 text-gold-400/70" />
                  {bandInfo.phone}
                </a>
              </li>
              <li>
                <a href={`mailto:${bandInfo.email}`} className="flex items-center gap-3 text-white/40 hover:text-gold-400 transition-colors duration-300 text-sm font-light">
                  <Mail className="w-4 h-4 text-gold-400/70" />
                  {bandInfo.email}
                </a>
              </li>
              <li className="flex items-center gap-3 text-white/40 text-sm font-light">
                <MapPin className="w-4 h-4 text-gold-400/70" />
                {bandInfo.territory}
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 pt-8 border-t border-white/5">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-white/30 text-xs tracking-wider">
              &copy; {currentYear} {bandInfo.name}. Sva prava zadržana.
            </p>
            <p className="text-white/30 text-xs tracking-wider italic">
              Muzika koja zaslađuje svaki trenutak
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
